<template>
	<div class="formTabWrapper">
		<div class="formTabTableWrap">
			<div class="formTabTableWrap_top">
				<div class="formTabTableWrap_top-title">Customer files</div>
				<div class="formTabTableWrap_top-add">
					<v-btn
							@click="onAddItem(true)" type="button"
							depressed
							class="mainBtn mainBtn-text"
					>
						<span class="btnIco"><svg-sprite icon-id="addItem" width="20" height="20"></svg-sprite></span>
						<span class="btnText">Add new file</span>
					</v-btn>
				</div>
			</div>
			<div class="formTabTableWrap_body">
				<no-info
						v-if="filesList && filesList.length <= 0"
						text="This customer has no uploaded documents."
				/>
				<main-table
						v-else
						padding="0"
						flag="customerFilesList"
						:headers="getHeaders"
						:listItems="filesList"
						:filtersList="{}"
						:is-hide-header="false"
						:items-per-page-amount="10"
						:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
						@updateClickButton="onClickButton"
						@updateClickButtonItemIndex="onClickButtonItemIndex"
				></main-table>
			</div>
		</div>
		<div style="display: none">
			<input
					type="file"
					ref="fileCustomer"
					accept="image/png, image/jpeg,image/jpg, image/bmp, image/png, application/pdf, image/gif"
					@change="setNewItem($event)"
					class="d-none"
			/>
			<a :href="downloadLink" target="_blank" download class="d-none" ref="downloadFile"></a>
		</div>
	</div>

</template>

<script>
import { mapActions, mapGetters } from "vuex";
// services
import { getAppUrl } from "@/services";
import NoInfo from "@/shared/NoInfo/NoInfo.vue";
import { customerFileTable } from "@/components/Accounting/CustomerInvoices/CustomerInvoicesCreate/defaultHeaders";

export default {
	name: "FourthTab",
	components: { NoInfo },
	props: { getPermissionAction: Boolean },

	computed: {
		...mapGetters([
			'customersList',
		]),
		getHeaders() {
			return customerFileTable;
		}
	},

	data: () => ({
		filesList: [],
		downloadLink: '',
		activeItem: null,
		activeItemIndex: null,
	}),
	methods: {
		...mapActions([ 'getDeleteFiles' ]),

		onAddItem() {
			this.$refs.fileCustomer.click();
		},

		onClickButtonItemIndex(index) {
			this.activeItemIndex = index;
		},
		onClickButton({ key, item }) {
			this.activeItem = item;

			if (key === "eye") {
				this.$emit('updatePreviewAction', item?.file ? item.file : getAppUrl + item.url);
			}
			if (key === "delete") {
				const id = item.customer_file_id;
				const idx = this.activeItemIndex;
				if (id) this.getDeleteFiles({ id });
				this.filesList.splice(idx, 1);
				this.$emit('updateData', this.filesList);
			}
		},
	},
	mounted() {
		this.filesList = this.customersList?.file || [];
	}
};
</script>

<style scoped lang="scss">
@import "@/assets/style/components/formTab/formTabTableWrap";
</style>
